var heading_default = {
  "fontElementMap": "WOb5x",
  "elementSpacing": "XPd8H",
  "headerOne": "X3hFm XPd8H",
  "headerTwo": "_1rWEn XPd8H",
  "headerThree": "VCTXo XPd8H",
  "headerFour": "bu9P1 XPd8H",
  "headerFive": "_45HG3 XPd8H",
  "headerSix": "_34cRM XPd8H",
  "child": "K8fmE"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
